module.exports = __webpack_public_path__ + "img/bb.0914c648.png";